// AppShell.tsx - the phone-first shell (S19): the 440px portrait .phone frame, the top bar (brand +
// live crumbs), and a slot for the rest of the screen. On desktop the same frame centers as a
// phone-in-a-frame (handled in shell.css). Everything else composes inside `children`.
import type { ReactNode } from 'react';

export interface AppShellProps {
  /** the "Local . $1/$3 . LIVE" style crumb line. */
  stakesLabel?: string;
  /** when provided, the wordmark becomes a button that returns to the Splash/home surface (GH4). */
  onHome?: () => void;
  /** when provided (GH9), a persistent "New hand" control appears in the top bar - the always-visible escape
   *  hatch that deals a fresh hand from any street/phase. Only wired on the live play surface. */
  onNewHand?: () => void;
  children: ReactNode;
}

export function AppShell({ stakesLabel = 'Local . $1/$3', onHome, onNewHand, children }: AppShellProps) {
  return (
    <div className="phone">
      <div className="top">
        <div className="brand">
          {onHome ? (
            <button type="button" className="brandhome" onClick={onHome} aria-label="Home">
              <img className="brandmark" src="/wordmark.png" alt="Postflop" />
            </button>
          ) : (
            <img className="brandmark" src="/wordmark.png" alt="Postflop" />
          )}
        </div>
        <div className="crumbs">
          {stakesLabel} . <span className="live">LIVE</span>
        </div>
        {onNewHand && (
          <button type="button" className="newhand" onClick={onNewHand} title="Deal a fresh hand">
            <span className="newhand-ic" aria-hidden="true">&#8635;</span>
            New hand
          </button>
        )}
      </div>
      {children}
    </div>
  );
}
